import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {Asset, Link} from "../../../../plugins/gatsby-plugin-atollon";
import StructuredText from "../custom-structured-text-renderer";
import {RightArrow} from "../../icons";

const TitleCardItem = ({title, items}) => {

    return (
        <section className='title-card-item'>
            <div className='title-card-item__inner'>
                {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}

                <div className='title-card-item__items'>
                    {items?.length > 0 && items.map((el, i) => (
                        <div key={i} className='title-card-item__item' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                            {el.image && <Asset asset={el.image}/>}
                            {el.title && <h3>{parse(el.title)}</h3>}
                            {el.richContent && <StructuredText data={el.richContent}/>}
                            {el.button.length > 0 &&
                                <Link {...el.button}>
                                    {el.button[0].title}
                                    <RightArrow color='#0D2E7A'/>
                                </Link>}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default TitleCardItem

export const query = graphql`
fragment TitleCardItemProps on DatoCmsTitleCardItem {
  ... on DatoCmsTitleCardItem {
    id
    title
    items {
      title
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
      button {
        ...LinkWithTitleProps
      }
    }
  }
}
`;